import { User } from "features/User/models";
import { Icon, IconProps } from "@chakra-ui/react";
import SimpleDiamond from "./Brand/SimpleDiamond";
import FlowerPurpleBackgroundFlower from "./Brand/FlowerPurpleBackgroundNew";
import FlowerGreenBackground from "./Brand/FlowerGreenBackground";
import OrangeFlower from "./Brand/OrangeFlower";

const BRAND_ICONS = [SimpleDiamond, OrangeFlower, FlowerPurpleBackgroundFlower, FlowerGreenBackground];

interface ProfileIconProps extends IconProps {
  user: Partial<User> | undefined;
  index?: number;
}

function getBaseIndex(user: Partial<User> | undefined): number {
  const letter = user?.lastName?.[0]?.toLowerCase() || user?.firstName?.[0]?.toLowerCase() || "a";
  return (letter.charCodeAt(0) - 97) % BRAND_ICONS.length;
}

export function ProfileIcon({ user, index, ...rest }: ProfileIconProps) {
  const icon = BRAND_ICONS[index || getBaseIndex(user)];
  return <Icon boxSize="100%" as={icon} {...rest} />;
}
